import React from "react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Author() {
  return <section className="bg-paper py-16 sm:py-20" aria-labelledby="author-title" data-id="element-44" data-mp="1ht3o1126fjyo">
      <div className="mx-auto max-w-5xl px-5" data-id="element-45" data-mp="1whqh05kq8a8d">
        <p className="text-center text-sm font-bold uppercase tracking-wider text-brand" data-id="element-46" data-mp="1wirpc2acyime">Why I created this</p>
        <h2 id="author-title" className="mt-3 text-center font-display text-[30px] font-black leading-tight text-ink sm:text-[42px]" data-id="element-47" data-mp="25hd73v809tm4">
          A message from <em className="text-brand" data-id="element-48" data-mp="20hh1xsnknw4z">Dr. Ryan Carter</em>
        </h2>

        <div className="mt-10 grid items-start gap-8 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-12" data-id="element-49" data-mp="2fg2rpvrads62">
          <div className="overflow-hidden rounded-3xl bg-navy" data-id="element-50" data-mp="2ag6ldpv49onc">
            <img src={images.author} alt="Dr. Ryan Carter, physical therapist" className="aspect-[4/5] w-full object-cover" data-id="element-51" data-mp="2aelo3shf3rls" />
            <div className="p-5 text-white" data-id="element-52" data-mp="g2ykphkgmits">
              <p className="font-display text-2xl font-black" data-id="element-53" data-mp="g49qto1do2o2">Dr. Ryan Carter</p>
              <p className="mt-1 text-sm text-white/70" data-id="element-54" data-mp="3gfnqnfqxzas6">Physical Therapist · Musculoskeletal Rehabilitation Educator</p>
            </div>
          </div>

          <div className="space-y-5 text-[17px] leading-relaxed text-muted" data-id="element-55" data-mp="3pf11abqsy5eh">
            <p data-id="element-56" data-mp="3pcy6zfim9q3y">
              I've spent years studying musculoskeletal rehabilitation and working with patients presenting with complex
              spinal complaints. And one thing became increasingly clear to me:
            </p>
            <p className="font-display text-2xl font-bold italic leading-snug text-ink" data-id="element-57" data-mp="7y1eshrg71if">
              Knowledge alone isn't always the problem.
            </p>
            <p data-id="element-58" data-mp="by1r9wuzl2mu">
              A physical therapist can spend years studying anatomy, biomechanics, assessment techniques, exercise therapy,
              and rehabilitation… and still feel overwhelmed when all of that information needs to be organized around one
              individual patient.
            </p>
            <p data-id="element-59" data-mp="2isf9ty1vypwi">
              That's the gap I wanted to address. I didn't create the Safe Spine Method™ to replace your education —{" "}
              <strong className="text-ink" data-id="element-60" data-mp="3h36py7280n5f">I created it to help you organize what you already know into a clearer workflow.</strong>
            </p>
            <blockquote className="border-l-4 border-brand pl-5 text-ink" data-id="element-61" data-mp="3v03iccxzmcof">
              <p className="italic" data-id="element-62" data-mp="3q1jv897nquuh">
                “I don't believe physical therapists need more information just for the sake of having more information. I
                believe they need practical systems that help them organize what they already know.”
              </p>
            </blockquote>
            <p data-id="element-63" data-mp="hms3f1n9m4dm">
              My goal was to take the most important components of evaluation, clinical reasoning, session planning,
              progression, reassessment, and patient communication and turn them into something you can actually refer to.
            </p>
            <p className="font-semibold text-ink" data-id="element-64" data-mp="mnfqjc8di12k">
              Not another endless course. Not another giant textbook. A practical professional reference system.
            </p>
            <p className="font-display text-xl font-bold italic text-navy" data-id="element-65" data-mp="1b7svoz1rr65w">— Dr. Ryan Carter</p>
          </div>
        </div>

        <div className="mt-12" data-id="element-66" data-mp="w8ywje154myd">
          <CtaButton label="I want Dr. Carter's system" caption="Instant access for only $27" data-id="element-67" data-mp="wc366qxdkawf" />
        </div>
      </div>
    </section>;
}